"use client"

import { ThemeProvider as NextThemesProvider } from "next-themes"
import type { ThemeProviderProps } from "next-themes"
import { useState, useEffect } from "react"

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  // Add state to track if component is mounted (client-side)
  const [mounted, setMounted] = useState(false)

  // When the component mounts, update the state
  useEffect(() => {
    setMounted(true)
  }, [])

  // If not mounted yet (server-side), render a div with suppressHydrationWarning
  if (!mounted) {
    return <div suppressHydrationWarning>{children}</div>
  }

  // Once mounted (client-side), render the actual theme provider
  return (
    <NextThemesProvider {...props}>
      {children}
    </NextThemesProvider>
  )
}

